import { render, staticRenderFns } from "./PlagueMonitoringForm.vue?vue&type=template&id=53f61d3e&scoped=true&lang=html&"
import script from "./PlagueMonitoringForm.vue?vue&type=script&lang=js&"
export * from "./PlagueMonitoringForm.vue?vue&type=script&lang=js&"
import style0 from "./PlagueMonitoringForm.vue?vue&type=style&index=0&id=53f61d3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f61d3e",
  null
  
)

export default component.exports